import { createSelector } from '@reduxjs/toolkit';
import { EHeatingType } from '../../../../packages/JsonQuery';
import { selectHeatingType } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Центральное газовое', value: EHeatingType.Gas },
  { label: 'Угольное', value: EHeatingType.Coal },
  { label: 'Печь', value: EHeatingType.Furnace },
  { label: 'Камин', value: EHeatingType.Fireplace },
  { label: 'Электрическое', value: EHeatingType.Electric },
  { label: 'Автономное газовое', value: EHeatingType.AutonomousGas },
  { label: 'Дизельное', value: EHeatingType.Diesel },
  { label: 'Твердотопливный котел', value: EHeatingType.SolidFuelBoiler },
  { label: 'Без отопления', value: EHeatingType.None },
];

export const selectHeatingTypeFilter = createSelector(selectHeatingType, value => ({
  label: 'Тип отопления',
  value: value?.length ? (value as EHeatingType[]) : [null],
  options: OPTIONS,
}));
